export const SET_ESRI_SUGGESTIONS = 'SET_ESRI_SUGGESTIONS';
export const CLEAR_ESRI_SUGGESTIONS = 'CLEAR_ESRI_SUGGESTIONS';

export const SET_ESRI_FIELDS = 'SET_ESRI_FIELDS';
export const CLEAR_ESRI_FIELDS = 'CLEAR_ESRI_FIELDS';

export const clearEsriSuggestions = {
  type: CLEAR_ESRI_SUGGESTIONS,
}

export const clearEsriFields = {
  type: CLEAR_ESRI_FIELDS,
}

export const setEsriSuggestions = (data) => {
  return {
    type: SET_ESRI_SUGGESTIONS,
    payload: data,
  }
}

export const setEsriFields = (data) => {
  return {
    type: SET_ESRI_FIELDS,
    payload: data,
  }
}